import API_ENDPOINTS from "../Config/api";

export async function fetchWithAuth(url, options = {}, retry = true) {
  const accessToken = localStorage.getItem('access_token');
  const body = options?.body;
  const isForm = typeof FormData !== 'undefined' && body instanceof FormData;

  const callerHeaders = options.headers || {};
  const callerHasCT = Object.keys(callerHeaders)
    .some(k => k.toLowerCase() === 'content-type');

  // Imposta Content-Type: application/json SOLO se:
  // - esiste un body
  // - NON è FormData
  // - il chiamante NON ha già messo Content-Type
  const defaultHeaders = {
    ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
    ...((body !== undefined && !isForm && !callerHasCT) ? { 'Content-Type': 'application/json' } : {}),
  };

  const headers = { ...defaultHeaders, ...callerHeaders };

  const config = {
    ...options,
    headers,
    credentials: 'include',
  };

  try {
    const response = await fetch(url, config);

    if ((response.status === 401 || response.status === 403) && retry) {
      const refreshed = await refreshAccessToken();
      if (refreshed) return fetchWithAuth(url, options, false);
      forceLogout();
      return null;
    }
    return response;

  } catch (err) {
    throw new Error('Errore di rete o server non raggiungibile');
  }
}

async function refreshAccessToken() {
  const refresh = localStorage.getItem('refresh_token');
  if (!refresh) { forceLogout(); return false; }

  const res = await fetch(API_ENDPOINTS.refreshToken, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ refresh }),
    credentials: 'include',
  });

  if (!res.ok) { forceLogout(); return false; }

  const data = await res.json();
  if (data.access) { localStorage.setItem('access_token', data.access); return true; }

  forceLogout(); return false;
}

function forceLogout() {
  localStorage.removeItem('access_token');
  localStorage.removeItem('refresh_token');
  localStorage.removeItem('token');
  window.location.href = '/';
}
